import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import NavigationBar from "./components/Navbar";
import Home from "./components/Home";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";
import BookEvent from "./components/BookEvent";
import Admin from "./components/Admin";
import Gallery from "./components/Gallery";
import Footer from "./components/Footer";
import AdminLogin from "./components/AdminLogin";
import NotFound from "./components/NotFound";
import PrivacyPolicy from "./components/PrivacyPolicy";
import SiteBackground from "./SiteBackground";

import { api } from "./api";

// We will use this when backend supports cookie-based session
async function checkAdminSession(): Promise<boolean> {
  try {
    // You’ll add this endpoint in Django: GET /api/auth/me/ (or similar)
    // For now, if you don’t have it, it will fail and we’ll fall back to token mode.
    await api.get("/auth/me/");
    return true;
  } catch {
    return false;
  }
}

const App: React.FC = () => {
  // Transitional: keep token ONLY in memory (not localStorage)
  const [token, setToken] = useState<string | null>(null);
  const [hasCookieSession, setHasCookieSession] = useState<boolean>(false);
  const [sessionChecked, setSessionChecked] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      const ok = await checkAdminSession();
      setHasCookieSession(ok);
      setSessionChecked(true);
    })();
  }, []);

  return (
    <Router>
      <SiteBackground />
      <div className="site-edge site-edge-top" />
      <div className="site-edge site-edge-bottom" />

      <div className="d-flex flex-column min-vh-100">
        <SiteBackground />
        <NavigationBar />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/book-event/" element={<BookEvent />} />
            <Route path="/privacy-policy/" element={<PrivacyPolicy />} />

            {/* New clean admin URLs */}
            <Route
              path="/admin"
              element={
                // wait until we know if cookie session exists
                !sessionChecked ? null : (hasCookieSession || token) ? (
                  <Admin token={token} setToken={setToken} />
                ) : (
                  <Navigate to="/admin/login" replace />
                )
              }
            />
            <Route path="/admin/login" element={<AdminLogin setToken={setToken} />} />

            {/* Backwards-compat: keep your old secret routes redirecting to new ones */}
            <Route
              path="/54a239ebdfed69e151b3cd0ab198103812be45f837f6a5409401227073aef95f"
              element={<Navigate to="/admin" replace />}
            />
            <Route
              path="/54a239ebdfed69e151b3cd0ab198103812be45f837f6a5409401227073aef95f/871869008b2558e5f73046c390fcecd0c834849e8d9c8575af48e98c4cd1be2f"
              element={<Navigate to="/admin/login" replace />}
            />

            <Route path="/gallery" element={<Gallery />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
